import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const page = {
  namespaced: true,
  state: {
    schemes: {},
    initialSchemes: {},
    models: {},
    parents: {},
    main: null,
    selectedItems: {
      keyValue: '',
      items: []
    },
    currentTabs: {},
    pageFilter: {},
    defaultFilter: {}
  },
  getters,
  mutations,
  actions
};
